import React, { ChangeEvent, useContext } from 'react'
import { IdentifyModalValue } from './StartModal'
import LazyImg from 'javascripts/common/LazyImg'
import styles from './ModalForuthView.module.scss'
import ChangeModal from './changeModal'

import Icon from '../../../../../assets/images/identify/icon_fourth.svg'
import ModalButton from 'spa/member/components/ModalButton'

export const ModalFourthView: React.FC<ChangeModal> = (props) => {
  const context = useContext(IdentifyModalValue)
  const options = [
    { value: 'no', text: '希望しない' },
    { value: 'yes', text: '希望する' },
  ]

  const changeSelectBox = (e: ChangeEvent<HTMLSelectElement>) => {
    const currentValue = e.currentTarget.value
    context.setCompanyNameSelected(currentValue)
    if (currentValue === 'yes') {
      context.setShowCompanyNameInputForm(true)
    } else {
      context.setShowCompanyNameAlertBox(false)
      context.setShowCompanyNameInputForm(false)
      context.setCompanyName('')
      context.setErrors([])
    }
  }

  const changeCompanyName = (e: ChangeEvent<HTMLInputElement>) => {
    const currentValue = e.currentTarget.value
    context.setCompanyName(currentValue)
    context.setErrors([])
  }

  const applyCorporateName = () => {
    return(
      <>
        <select value={context.companyNameSelected} className={styles.selectBox} onChange={(event) => changeSelectBox(event)}>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
      </>
    )
  }

  const companyNameForm = () => {
    if (context.showCompanyNameInputForm) {
      return(
          <>
            <div className={styles.sectionInput}>
              <input
                  className={styles.inputText + (context.errors.includes('company_name') ? ' input-error' : '')}
                  type="text"
                  value={context.companyName}
                  placeholder="法人名を入力してください"
                  onChange={(event) => changeCompanyName(event)}
              />
              {context.errors.includes('company_name') && <div className="error-message">旧漢字等、保存できない文字列が含まれています</div>}
            </div>
          </>
      )
    }
  }

  const renderAlertBox = () => {
    return(
      <>
        {context.showCompanyNameAlertBox && <div className={styles.alertBox}>
          <p>法人名が入力されて<br/>いません</p>
          <span onClick={ () => {context.setShowCompanyNameAlertBox( false )} }>×</span>
        </div> }
      </>
    )
  }

  const nextAction = () => {
    if (context.companyNameSelected === 'yes' && context.companyName === '') {
      context.setShowCompanyNameAlertBox(true)
    } else {
      if (context.companyNameSelected === 'no') {
        context.setCompanyName('')
      }
      context.setShowCompanyNameAlertBox(false)
      context.setApplyCompany(context.companyNameSelected)
      props.changeModal('fifthModal')
    }
  }

  const prevAction = () => {
    context.setShowCompanyNameAlertBox(false)
    props.changeModal('thirdModal')
  }

  const cancelAction = () => {
    context.setShowCompanyNameAlertBox(false)
    props.changeModal('')
  }

  return (
    <>
      <div>
        <div className={styles.overlay}>
          <div className={`${styles.modalContainer} js-modal-container`}>
            <div className={styles.identificationIcon}><LazyImg src={Icon} /></div>
            <div className={styles.sectionTitle}><p><span>法人名義</span>の希望</p></div>
            <div className={styles.sectionText}>
              <p>法人名義での申請の希望有無を選択してください。<br/>
              「希望する」を選択した場合、必ず法人名義を入力してください。</p>
            </div>
            <div className={styles.sectionSelect}>{applyCorporateName()}</div>
            {companyNameForm()}
            <div className={styles.sectionBtn}>
              <ModalButton buttonType='BACK' onClick={() => prevAction()}>1つ前に戻る</ModalButton>
              <ModalButton buttonType='NEXT' onClick={() => nextAction()}>次へ</ModalButton>
              {renderAlertBox()}
            </div>
              <div className={styles.sectionBtnClose}><button onClick={() => cancelAction()} className={styles.btnItemClose}>キャンセル</button></div>
          </div>
        </div>
      </div>
    </>
  )
}
